import {DateTimePicker, DateTimePickerProps, DateValue} from "@mantine/dates";
import {forwardRef} from "react";
import {Box, BoxProps, Tooltip} from "@mantine/core";
import dayjs, {Dayjs} from "dayjs";
import {IconClock} from "@tabler/icons-react";
import classes from "./ZoneAwareDateTimePicker.module.css";

interface ZoneAwareDateTimePickerProps extends BoxProps {
    timezone?: string
    value: Dayjs | undefined
    onChange: (value: Dayjs) => void
    label?: string
    dateTimeProps?: Exclude<DateTimePickerProps, 'value' | 'onChange'> & { "data-testid"?: string }
    readonly?: boolean
}

export const ZoneAwareDateTimePicker = forwardRef<HTMLDivElement, ZoneAwareDateTimePickerProps>(
    ({value, onChange, label, timezone, dateTimeProps, readonly = false, ...others}, ref) => {
        let dateValue: Date | undefined
        if (value) {
            dateValue = value.tz(timezone).tz(undefined, true).toDate()
        }

        const onSetTime = (dt: DateValue, keepLocalTime: boolean) => {
            try {
                onChange(dayjs(dt).tz(timezone, keepLocalTime))
            } catch (ex) {
                console.error(ex)
            }
        }

        return (
            <Box ref={ref} {...others}>
                <DateTimePicker data-testid="input-datetime" label={label} required={true} value={dateValue}
                                withSeconds
                                disabled={readonly}
                                onChange={(value) => onSetTime(value, true)}
                                timeInputProps={{"aria-label": "time-input"}}
                                rightSection={
                                    readonly ? <></> :
                                        <Tooltip label={"Set time to now."}>
                                            <Box style={{
                                                display: "grid",
                                                grid: "auto/auto",
                                                alignItems: "center",
                                                cursor: "pointer",
                                            }}>
                                                <IconClock className={classes.now}
                                                           onClick={() => onSetTime(dayjs().tz(timezone, false).toDate(), false)}/>
                                            </Box>
                                        </Tooltip>
                                }
                                {...dateTimeProps}
                />
            </Box>
        )
    }
)
